var _ellipse, _rect, _rect2, _ellipse2, _ellipse3, _path, _g, _rect3, _rect4, _circle, _rect5, _circle2, _path2, _path3, _rect6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayUserLevel2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.3364,
    cy: 48.7684,
    rx: 34.2985,
    ry: 32.6908,
    fill: "#EBEBEB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.4082,
    y: 15.7681,
    width: 20.8069,
    height: 15.0056,
    rx: 2,
    transform: "rotate(-30.018 67.4082 15.7681)",
    fill: "#EBEBEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4656,
    width: 20.8069,
    height: 15.0056,
    rx: 2,
    transform: "rotate(52.5921 66.4656 0)",
    fill: "#EBEBEB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.5794,
    cy: 38.5856,
    rx: 1.60774,
    ry: 2.14366,
    fill: "#9C9C9C"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.1539,
    cy: 39.6578,
    rx: 1.60774,
    ry: 2.14366,
    fill: "#9C9C9C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6724 49.924C48.3895 50.1339 48.3287 50.535 48.5578 50.8025C49.2842 51.6506 50.1615 52.3593 51.1472 52.8918C52.3201 53.5254 53.6179 53.8939 54.9489 53.9712C56.2798 54.0486 57.6115 53.8328 58.85 53.3393C59.8907 52.9246 60.8442 52.3222 61.6639 51.5639C61.9224 51.3247 61.9084 50.9193 61.6518 50.6781C61.3951 50.4369 60.9931 50.4517 60.7319 50.6879C60.0419 51.3117 59.245 51.8088 58.3778 52.1544C57.3127 52.5789 56.1675 52.7644 55.0228 52.6979C53.8782 52.6314 52.7621 52.3145 51.7534 51.7696C50.932 51.3258 50.1981 50.7398 49.585 50.0403C49.3528 49.7754 48.9553 49.7142 48.6724 49.924Z",
    fill: "#9C9C9C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_714_1554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.691 66.9556H23.5784C22.0872 66.9556 21.1205 68.5287 21.7941 69.859L32.1458 90.3032C32.4864 90.9757 33.1762 91.3997 33.9301 91.3997H99.9319C100.732 91.3997 101.455 90.9228 101.77 90.1873L110.529 69.7432C111.095 68.4235 110.127 66.9556 108.691 66.9556Z",
    fill: "#F6F6F6"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68.4119,
    y: 59.7773,
    width: 41.8883,
    height: 2.12558,
    rx: 1.06279,
    transform: "rotate(37.1195 68.4119 59.7773)",
    fill: "#EBEBEB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 92.5935,
    y: 86.7124,
    width: 13.8162,
    height: 15.9418,
    rx: 2,
    transform: "rotate(-47.5355 92.5935 86.7124)",
    fill: "#EBEBEB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.1205,
    cy: 68.5497,
    r: 6.90812,
    fill: "#EBEBEB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 40.937,
    height: 2.12558,
    rx: 1.06279,
    transform: "matrix(-0.797379 0.603479 0.603479 0.797379 44.417 57.9375)",
    fill: "#EBEBEB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.609,
    cy: 63.2362,
    r: 6.90812,
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2659 101.496C36.2659 96.8456 34.3624 92.3853 30.9741 89.0966C27.5858 85.808 22.9903 83.9604 18.1985 83.9604C13.4067 83.9604 8.81122 85.808 5.42292 89.0966C2.03463 92.3853 0.131104 96.8456 0.131104 101.496H4.95309C4.95309 98.0869 6.34858 94.8169 8.83258 92.406C11.3166 89.9951 14.6856 88.6406 18.1985 88.6406C21.7114 88.6406 25.0804 89.9951 27.5644 92.406C30.0484 94.8169 31.4439 98.0869 31.4439 101.496H36.2659Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0776 101.496C33.0776 96.8456 34.9811 92.3853 38.3694 89.0966C41.7577 85.808 46.3532 83.9604 51.145 83.9604C55.9368 83.9604 60.5323 85.808 63.9206 89.0966C67.3089 92.3853 69.2124 96.8456 69.2124 101.496L64.3904 101.496C64.3904 98.0869 62.9949 94.8169 60.5109 92.406C58.0269 89.9951 54.6579 88.6406 51.145 88.6406C47.6321 88.6406 44.2631 89.9951 41.7791 92.406C39.2951 94.8169 37.8996 98.0869 37.8996 101.496L33.0776 101.496Z",
    fill: "#EBEBEB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 13.8162,
    height: 15.9418,
    rx: 2,
    transform: "matrix(-0.675133 -0.737696 -0.737696 0.675133 23.3447 83.5244)",
    fill: "#EBEBEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_714_1554",
    x: 11.5759,
    y: 60.9556,
    width: 109.117,
    height: 44.4443,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_714_1554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_714_1554",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayUserLevel2);
export default __webpack_public_path__ + "static/media/grayUserLevel2.7777b3f0959dd275add3b6a2e80d7977.svg";
export { ForwardRef as ReactComponent };